window.change_part_name = function(element) {
  var record = window.eng_products_record;

  var field0 = "Part Name",
      width0 = "width: 250px;",
      field1 = "Internal Part ID",
      width1 = "width: 150px;",
      field2 = "Customer Part Number",
      width2 = "width: 100px;";

  var row = $(element).closest('tr');

  $(element).autocomplete({
    minLength: 0,
    source: function(request, response) {
      var results = $.ui.autocomplete.filter(record, request.term);
      response(results.slice(0, 20));
    },
    focus: function(event, ui) { return false; },
    select: function(event, ui) {
      $(this).val(ui.item.value);
      $(row).find(".eng_product_id").val(ui.item.key);
      $(row).find("td:nth-child(3)").text(ui.item.internal_part_id);
      $(row).find("td:nth-child(4)").text(ui.item.customer_part_number);
      $(row).find("td:nth-child(5)").text(ui.item.unit);
      return false;
    },
    create: function () {
      $(this).data('ui-autocomplete')._renderMenu = function (ul, items) {
        var self = this;
        ul.append(`
          <li class='ui-autocomplete-category' aria-label='header'>
            <div class='listACR1 listHeader' style='${width0}'>${field0}</div>
            <div class='listACR2 listHeader' style='${width1}'>${field1}</div>
            <div class='listACR3 listHeader' style='${width2}'>${field2}</div>
          </li>
        `);
        $.each(items, function (index, item) {
          self._renderItemData(ul, item);
        });
      };
      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
        return $("<li>")
          .data("item.autocomplete", item)
          .append(`
            <div class='listACR1' style='${width0}'>${item.part_name}</div>
            <div class='listACR2' style='${width1}'>${item.internal_part_id}</div>
            <div class='listACR3' style='${width2}'>${item.customer_part_number}</div>
          `)
          .appendTo(ul);
      };
    }
  });
};
